"use client";

import { createContext, useContext } from "react";

/** 与 Flutter `MacaronCardScope`：首层 Column 在 Card 内用 12px 间距，子树重置为 false */
export const MacaronCardActiveContext = createContext(false);

/** 与 Flutter `MacaronButtonScope`：Row 在 Button 内用 4px 间距；Button 默认撑满可用宽度，同行布局再按需收窄 */
export const MacaronButtonInnerContext = createContext(false);
export const MacaronButtonFillContext = createContext(true);
export const MacaronSelectionItemScopeContext = createContext(false);
export const MacaronSelectionItemActiveContext = createContext(false);
export const MacaronNumericQuantityLabelContext = createContext(false);

export function useMacaronCardActive() {
  return useContext(MacaronCardActiveContext);
}

export function useMacaronButtonInner() {
  return useContext(MacaronButtonInnerContext);
}

export function useMacaronButtonFill() {
  return useContext(MacaronButtonFillContext);
}

export function useMacaronSelectionItemActive() {
  return useContext(MacaronSelectionItemActiveContext);
}

export function useMacaronSelectionItemScope() {
  return useContext(MacaronSelectionItemScopeContext);
}

export function useMacaronNumericQuantityLabel() {
  return useContext(MacaronNumericQuantityLabelContext);
}
